export const FILTER_TYPES = {
    text: 'text',
    checkbox: 'checkbox',
};
